import * as Model from "@effect/sql/Model";
import { Schema } from "effect";
import { AgentPlatform } from "./AgentRelease.ts";

/**
 * clawd channel — promotion lane operators flip between.
 *
 * @since 1.0.0
 */
export const AgentChannelName = Schema.Literal("dev", "beta", "stable");
export type AgentChannelName = Schema.Schema.Type<typeof AgentChannelName>;

/**
 * AgentChannel model — one row per (channel, platform), pre-seeded by
 * the migration. `currentReleaseId` is NULL until an operator promotes
 * a published release; `paused` is a kill switch surfaced in Phase 5.
 *
 * Maps 1:1 to the `agent_channels` table.
 *
 * @since 1.0.0
 */
export class AgentChannel extends Model.Class<AgentChannel>("AgentChannel")({
  id: Model.Generated(Schema.String),
  channel: AgentChannelName,
  platform: AgentPlatform,
  currentReleaseId: Schema.NullOr(Schema.String),
  paused: Schema.Boolean,
  updatedAt: Model.DateTimeUpdateFromDate,
}) {}
